import React from 'react'

export function Header() {
  return (
    <header className="header">
      <h1>AI Portrait Adapter</h1>
      <p>Générateur d'images IA avec Gemini</p>
    </header>
  )
}